import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NegotiationCaseStep } from '../NegotiationCaseStep/NegotiationCaseStep';
import { NegotiationCaseStepActions } from '../NegotiationCaseStep/NegotiationCaseStep.actions';
import { RefineQuoteDetailsStep } from '../RefineQuoteDetailsStep/RefineQuoteDetailsStep';
import { RefineQuoteDetailsStepActions } from '../RefineQuoteDetailsStep/RefineQuoteDetailsStep.actions';
import { SelectQuote } from '../SelectQuoteStep/SelectQuoteStep';
import { SelectQuoteActions } from '../SelectQuoteStep/SelectQuoteStep.actions';
import { useDemandDetail } from '@/legacy/modules/Module.hooks';
import { I18nNamespace } from '~/common/types';
import { DialogWizard } from '~/components/DialogWizard/DialogWizard';

import { NegotiationCaseCreateWizardDefaultState } from './NegotiationCaseCreateWizard.schema';

interface NegotiationCaseCreateWizardProps {
  onClose: () => void;
}

export const NegotiationCaseCreateWizard = ({ onClose }: NegotiationCaseCreateWizardProps) => {
  const { t } = useTranslation(I18nNamespace.demand, { keyPrefix: 'NegotiationCaseCreate.wizard' });

  const steps = useMemo(
    () => [
      {
        label: t('SelectQuote.step.label'),
        description: t('SelectQuote.step.description'),
        component: SelectQuote,
        actions: SelectQuoteActions,
      },
      {
        label: t('RefineQuoteDetails.step.label'),
        description: t('RefineQuoteDetails.step.description'),
        component: RefineQuoteDetailsStep,
        actions: RefineQuoteDetailsStepActions,
      },
      {
        label: t('CreateNegotiationCase.step.label'),
        component: NegotiationCaseStep,
        actions: NegotiationCaseStepActions,
      },
    ],
    [t],
  );

  const { demandId } = useDemandDetail();

  const initialState = {
    ...NegotiationCaseCreateWizardDefaultState,
    demand: {
      id: demandId,
    },
  };

  return <DialogWizard title={t('title')} onClose={onClose} steps={steps} initialState={initialState} />;
};
